import React, {Component} from 'react';
import {Modal, Button, Row, Col}  from 'react-bootstrap'
import MeterDropdown from '../Controls/MeterDropdown';
import StyleDropdown from '../Controls/StyleDropdown';
import UnitsDropdown from '../Controls/UnitsDropdown';
import TempDropdown from '../Controls/TempDropdown'
import {nestedProp} from '../../Utils/object'
import { typeToEditGroup, allEditProps, groupToEditProps } from './MeterTypes';

import '../report-header.css'
import './metermassedit.css'
import { isplausibleFactor } from '../../Edit/validators';

export default class MeterMassEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: null,
      changedInputs: [],
    }
    this.editProps = allEditProps()
    this.show = props.show;
    this.handleClose = this.handleClose.bind(this);
    this.linkedChange = this.linkedChange.bind(this)
    this.validate = this.validate.bind(this);
  }
  componentDidMount () {
    this.initFromProps()
 }
  componentDidUpdate(prevProps) {
    if (prevProps?.data !== this.props?.data)
      this.initFromProps()
  }
  initFromProps() {
    const tp = this.props
    if (tp?.devices && tp?.data) {
      const editgroup = groupToEditProps(typeToEditGroup(tp.type))
      this.editProps = editgroup
      let newState = {changedInputs: []}
      editgroup.forEach(item => {
        const matchData = tp.data.map(meter => nestedProp(tp.devices, meter+item.dataKey))
        const unique = [...new Set(matchData)]
        const stateVal = unique.length === 1 ? unique[0] : undefined
        newState[item.stateKey] = stateVal
      })
      this.setState(newState)
    }
  }
  handleClose() {
    this.show = false;
    this.props.hide();
  }

  handleDropDown = (value, props) => {
    const newState = {property: props.id, value: value}
    const currState = this.state.changedInputs
    const changedIndex = currState.findIndex(item => item.property === props.id)
    changedIndex > -1 ? currState[changedIndex] = newState : currState.push(newState)
  }
  handleChange = (event) => {
    const apiData = {property:event.target.id, value: event.target.value}
    let temp = this.state.changedInputs;
    const changedIndex = temp.findIndex(item => item.property === event.target.id)
    changedIndex >= 0 ? temp[changedIndex] = apiData : temp.push(apiData);
    const localData = this.editProps.find(item=>item.dataKey === '.'+event.target.id).stateKey
    this.setState({changedInputs: temp, [localData]:event.target.value})
  }
  persistChange(key, value) {
    const apiData = {property:key, value: value}
    let temp = this.state.changedInputs;
    const changedIndex = temp.findIndex(item => item.property === key)
    changedIndex >= 0 ? temp[changedIndex] = apiData : temp.push(apiData);
    const localData = this.editProps.find(item=>item.dataKey === '.'+key).stateKey
    this.setState({changedInputs: temp, [localData]:value})
  }
  
  validate() {
    let msg = ''
    const validIndex = this.state.changedInputs.findIndex(item =>item.property === 'factor')
    if (validIndex > -1)
      msg = isplausibleFactor(this.state.changedInputs[validIndex].value)
    
    if (msg === '') {
      this.handleClose();
      if (this.props.onChange)
        this.props.onChange(this.state);
    }
    else {
      this.setState({errMsg: msg})
    }
  }
  linkedChange(evt) { // ties imr date to changing IMR
    console.log (this.state.changedInputs)
    if (this.state.changedInputs.some(i => i.property === 'initial_meter_read')) {
      const newVal = new Date().toISOString().replace('T', ' ')
      this.persistChange('initial_meter_time', newVal)
    }
  }
  unitsDropdown (prop) {
    if (prop.stateKey === 'temperature')
      return ( <TempDropdown anchorStyle="dialog-anchor" id="units"
        value={this.state[prop.stateKey]} onUpdate={this.handleDropDown}/>)
    else
      return ( <UnitsDropdown anchorStyle="dialog-anchor" id="units"
        value={this.state[prop.stateKey]} onUpdate={this.handleDropDown}/>
    )
  }
  displayRows() {
    const toEdit = groupToEditProps(typeToEditGroup(this.props?.type))
    return toEdit.map (prop=> {
      switch(prop.dataKey) {
        case ".meter_type":
          return (
          <Row className='mt-4' key="r1">
            <Col md="4" className="label-item">Utility</Col>
            <Col><MeterDropdown anchorStyle="dialog-anchor" id="meter_type"
              value={this.state[prop.stateKey]} onUpdate={this.handleDropDown}/></Col>
          </Row>)
        case ".meter_style":
          return(
          <Row className='mt-4' key="r2">
            <Col md="4" className="label-item">Style</Col>
            <Col><StyleDropdown anchorStyle="dialog-anchor" id="meter_style"  
              value={this.state[prop.stateKey]} onUpdate={this.handleDropDown}/></Col>
          </Row>)
        case ".units":
          return (
          <Row className='mt-4' key="r3">
            <Col md="4" className="label-item">Units</Col>
            <Col>{this.unitsDropdown(prop)}</Col>
          </Row>)
        case ".factor":
          return (
          <Row className='mt-4' key="r4">
            <Col md="4" className="label-item">Factor</Col>
            <Col><input className="input-item" type="number" id="factor" 
              value={this.state[prop.stateKey]} onChange={this.handleChange}/></Col>
          </Row>)
        case ".initial_meter_read":
          return(
            //this.Row(this.labelCol("Initial Meter Read"), this.InputCol(type, id, value))
          <Row className='mt-4' key="r5">
            <Col md="4" className="label-item">Initial Meter Read</Col>
            <Col><input className="input-item" type="number" id="initial_meter_read" 
              value={this.state[prop.stateKey]} onChange={this.handleChange} onBlur={this.linkedChange} /></Col>
          </Row>)
        case ".initial_meter_time":
          return(
          <Row className='mt-4' key="r6">
            <Col md="4" className="label-item">IMR Date</Col>
            <Col><input className="input-item" type="text" id="initial_meter_time"
              value={this.state[prop.stateKey]} onChange={this.handleChange}/></Col>
          </Row>)
        case ".meter_serial_number":
          return(
          <Row className='mt-4' key="r7">
            <Col md="4" className="label-item">Serial Number</Col>
            <Col><input className="input-item" type="text" id="meter_serial_number"
              value={this.state[prop.stateKey]} onChange={this.handleChange}/></Col>
          </Row>)
        case ".note":
          return (
          <Row className='mt-4' key="r8">
            <Col md="4" className="label-item">Notes</Col>
            <Col><input className="input-item" type="text" id="note"
              value={this.state[prop.stateKey]} onChange={this.handleChange}/></Col>
          </Row>)
        default:
          return null
      }})
  }
  render() {
    const msg = this.props.data.length ? this.state.errMsg : "Check some boxes to mass edit those devices"
    const okDisabled = !this.props.data.length
    return(
      <Modal show={this.props.show} onHide={this.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit {this.props?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {this.displayRows()}
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-error">{msg}</div>
        <Button className="custom-btn-cancel" onClick={this.handleClose}>
          Cancel
        </Button>
        <Button className="custom-ok-btn" onClick={this.validate} disabled={okDisabled}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
    )
  }
}  